(() => {
  if (document.documentElement.classList.contains('gm-ref-ready')) return;
  document.documentElement.classList.add('gm-ref-ready');

  const locale = (document.documentElement.lang || 'en').slice(0, 2).toLowerCase();
  const lang = ['de', 'fr', 'it', 'es'].includes(locale) ? locale : 'en';
  const prefix = lang === 'en' ? '' : `/${lang}`;
  const path = location.pathname.replace(/^\/(de|fr|it|es)(?=\/|$)/, '') || '/';
  const copy = {
    en: {
      announcement: '10% off your first order - code WELCOME10', shop: 'Shop all', safety: 'Work & Safety', water: 'Water & Barefoot', boots: 'Boots & Rain',
      hero: 'Footwear for work, water and everyday movement', heroSub: 'Practical shoes for demanding workdays, wet conditions and comfortable daily wear.', heroCta: 'Shop footwear',
      trust1: 'Secure checkout', trust2: 'Clear size support', trust3: '14-day returns', trust4: 'Responsive customer care',
      needs: 'Shop by need', needsSub: 'Go straight to the footwear made for your day.', popular: 'Popular picks', popularSub: 'Four practical starting points from the GemChve range.', view: 'View all',
      safetySub: 'Protective work styles', waterSub: 'Flexible, quick-drying styles', bootsSub: 'Coverage for wet weather', comfort: 'Everyday comfort', comfortSub: 'Support for daily movement',
      why: 'A clearer way to choose footwear', whySub: 'Compare by use, check the size information and review delivery and return details before you buy.',
      collection: 'Shop all footwear', collectionSub: 'Filter by use, then compare the styles that fit your routine.', all: 'All', noItems: 'No products are available in this category yet.',
      about: 'About GemChve', aboutText: 'Practical footwear for work, water, wet weather and everyday comfort.', help: 'Help', legal: 'Legal', contact: 'Contact', shipping: 'Shipping', refund: 'Returns & refunds', privacy: 'Privacy', terms: 'Terms',
      assurance1: 'Secure checkout', assurance2: 'Delivery cost shown before payment', assurance3: '14-day return policy'
    },
    de: {
      announcement: '10 % Rabatt auf Ihre erste Bestellung - Code WELCOME10', shop: 'Alle Schuhe', safety: 'Arbeit & Sicherheit', water: 'Wasser & Barfuß', boots: 'Stiefel & Regen',
      hero: 'Schuhe für Arbeit, Wasser und Alltag', heroSub: 'Praktische Schuhe für anspruchsvolle Arbeitstage, nasse Bedingungen und bequemen Alltag.', heroCta: 'Schuhe entdecken',
      trust1: 'Sicherer Checkout', trust2: 'Klare Größenhilfe', trust3: '14 Tage Rückgabe', trust4: 'Schneller Kundenservice',
      needs: 'Nach Einsatzbereich kaufen', needsSub: 'Finden Sie direkt die passenden Schuhe für Ihren Alltag.', popular: 'Beliebte Auswahl', popularSub: 'Vier praktische Einstiege in das GemChve Sortiment.', view: 'Alle ansehen',
      safetySub: 'Schutzschuhe für die Arbeit', waterSub: 'Flexible, schnelltrocknende Modelle', bootsSub: 'Schutz bei nassem Wetter', comfort: 'Alltagskomfort', comfortSub: 'Unterstützung für tägliche Bewegung',
      why: 'Schuhe einfacher auswählen', whySub: 'Nach Einsatz vergleichen, Größenangaben prüfen und Versand sowie Rückgabe vor dem Kauf ansehen.',
      collection: 'Alle Schuhe', collectionSub: 'Nach Einsatz filtern und passende Modelle vergleichen.', all: 'Alle', noItems: 'In dieser Kategorie sind derzeit keine Produkte verfügbar.',
      about: 'Über GemChve', aboutText: 'Praktische Schuhe für Arbeit, Wasser, Regenwetter und Alltagskomfort.', help: 'Hilfe', legal: 'Rechtliches', contact: 'Kontakt', shipping: 'Versand', refund: 'Rückgabe & Erstattung', privacy: 'Datenschutz', terms: 'AGB',
      assurance1: 'Sicherer Checkout', assurance2: 'Versandkosten vor der Zahlung sichtbar', assurance3: '14 Tage Rückgaberecht'
    },
    fr: {
      announcement: '10 % de réduction sur votre première commande - code WELCOME10', shop: 'Tous les modèles', safety: 'Travail & sécurité', water: 'Eau & pieds nus', boots: 'Bottes & pluie',
      hero: 'Des chaussures pour le travail, l’eau et le quotidien', heroSub: 'Des modèles pratiques pour le travail, les conditions humides et le confort quotidien.', heroCta: 'Voir les chaussures',
      trust1: 'Paiement sécurisé', trust2: 'Guide des tailles clair', trust3: 'Retours sous 14 jours', trust4: 'Service client réactif',
      needs: 'Choisir selon l’usage', needsSub: 'Trouvez directement les chaussures adaptées à votre journée.', popular: 'Modèles populaires', popularSub: 'Quatre points de départ pratiques dans la gamme GemChve.', view: 'Tout voir',
      safetySub: 'Modèles de protection au travail', waterSub: 'Modèles souples à séchage rapide', bootsSub: 'Protection par temps humide', comfort: 'Confort quotidien', comfortSub: 'Soutien pour les mouvements quotidiens',
      why: 'Choisir ses chaussures plus facilement', whySub: 'Comparez par usage, consultez les tailles, la livraison et les retours avant l’achat.',
      collection: 'Toutes les chaussures', collectionSub: 'Filtrez par usage, puis comparez les modèles adaptés.', all: 'Tous', noItems: 'Aucun produit n’est disponible dans cette catégorie pour le moment.',
      about: 'À propos de GemChve', aboutText: 'Des chaussures pratiques pour le travail, l’eau, la pluie et le confort quotidien.', help: 'Aide', legal: 'Informations légales', contact: 'Contact', shipping: 'Livraison', refund: 'Retours & remboursements', privacy: 'Confidentialité', terms: 'Conditions',
      assurance1: 'Paiement sécurisé', assurance2: 'Frais de livraison affichés avant paiement', assurance3: 'Politique de retour de 14 jours'
    },
    it: {
      announcement: '10% di sconto sul primo ordine - codice WELCOME10', shop: 'Tutti i modelli', safety: 'Lavoro & sicurezza', water: 'Acqua & piede libero', boots: 'Stivali & pioggia',
      hero: 'Calzature per lavoro, acqua e vita quotidiana', heroSub: 'Modelli pratici per giornate di lavoro impegnative, condizioni bagnate e comfort quotidiano.', heroCta: 'Scopri le calzature',
      trust1: 'Checkout sicuro', trust2: 'Guida taglie chiara', trust3: 'Resi entro 14 giorni', trust4: 'Assistenza reattiva',
      needs: 'Acquista per utilizzo', needsSub: 'Trova subito le calzature adatte alla tua giornata.', popular: 'Scelte popolari', popularSub: 'Quattro punti di partenza pratici della gamma GemChve.', view: 'Vedi tutto',
      safetySub: 'Modelli protettivi da lavoro', waterSub: 'Modelli flessibili ad asciugatura rapida', bootsSub: 'Protezione per il tempo umido', comfort: 'Comfort quotidiano', comfortSub: 'Supporto per il movimento quotidiano',
      why: 'Un modo più semplice per scegliere', whySub: 'Confronta per utilizzo, controlla le taglie, la spedizione e i resi prima dell’acquisto.',
      collection: 'Tutte le calzature', collectionSub: 'Filtra per utilizzo e confronta i modelli adatti.', all: 'Tutti', noItems: 'Nessun prodotto è disponibile in questa categoria.',
      about: 'Informazioni su GemChve', aboutText: 'Calzature pratiche per lavoro, acqua, pioggia e comfort quotidiano.', help: 'Aiuto', legal: 'Note legali', contact: 'Contatti', shipping: 'Spedizione', refund: 'Resi & rimborsi', privacy: 'Privacy', terms: 'Termini',
      assurance1: 'Checkout sicuro', assurance2: 'Costo di spedizione visibile prima del pagamento', assurance3: 'Politica di reso di 14 giorni'
    },
    es: {
      announcement: '10 % de descuento en tu primer pedido - código WELCOME10', shop: 'Todos los modelos', safety: 'Trabajo & seguridad', water: 'Agua & descalzo', boots: 'Botas & lluvia',
      hero: 'Calzado para trabajo, agua y uso diario', heroSub: 'Modelos prácticos para jornadas exigentes, condiciones húmedas y comodidad cotidiana.', heroCta: 'Ver calzado',
      trust1: 'Pago seguro', trust2: 'Guía de tallas clara', trust3: 'Devoluciones en 14 días', trust4: 'Atención al cliente ágil',
      needs: 'Comprar por uso', needsSub: 'Encuentra directamente el calzado adecuado para tu día.', popular: 'Modelos populares', popularSub: 'Cuatro opciones prácticas para conocer la gama GemChve.', view: 'Ver todo',
      safetySub: 'Modelos de protección laboral', waterSub: 'Modelos flexibles de secado rápido', bootsSub: 'Protección para clima húmedo', comfort: 'Comodidad diaria', comfortSub: 'Soporte para el movimiento diario',
      why: 'Una forma más clara de elegir calzado', whySub: 'Compara por uso y revisa talla, envío y devoluciones antes de comprar.',
      collection: 'Todo el calzado', collectionSub: 'Filtra por uso y compara los modelos que encajan contigo.', all: 'Todos', noItems: 'Todavía no hay productos disponibles en esta categoría.',
      about: 'Sobre GemChve', aboutText: 'Calzado práctico para trabajo, agua, lluvia y comodidad cotidiana.', help: 'Ayuda', legal: 'Legal', contact: 'Contacto', shipping: 'Envío', refund: 'Devoluciones & reembolsos', privacy: 'Privacidad', terms: 'Términos',
      assurance1: 'Pago seguro', assurance2: 'Coste de envío visible antes del pago', assurance3: 'Política de devolución de 14 días'
    }
  }[lang];

  const style = document.createElement('style');
  style.id = 'gm-reference-style';
  style.textContent = `
:root{--gm-ink:#111411;--gm-muted:#5f665f;--gm-line:#dfe3de;--gm-soft:#f3f5f2;--gm-accent:#155e45;--gm-white:#fff}
body{color:var(--gm-ink)}[role=complementary],aside{background:var(--gm-ink)!important;color:#fff!important;min-height:34px}[role=complementary] p,aside p{color:#fff!important;font-size:12px!important;font-weight:650!important;margin:0!important}
header,.shopify-section-group-header-group{background:rgba(255,255,255,.98)}header{border-bottom:1px solid var(--gm-line)}header nav ul{gap:clamp(14px,1.5vw,26px)!important}header nav a{font-size:14px!important;font-weight:600!important}
.gm-wrap{width:min(1420px,100%);margin:auto}.gm-section{padding:clamp(44px,6vw,82px) clamp(20px,4vw,64px)}.gm-head{display:flex;align-items:end;justify-content:space-between;gap:20px;margin-bottom:28px}.gm-head h2,.gm-collection-intro h1{font-size:clamp(29px,3vw,46px);line-height:1.08;margin:0 0 9px}.gm-head p,.gm-collection-intro p{color:var(--gm-muted);margin:0;max-width:700px}.gm-view{color:var(--gm-ink);font-weight:700;text-underline-offset:5px;white-space:nowrap}
.gm-trust{border-bottom:1px solid var(--gm-line);background:#fff}.gm-trust .gm-wrap{display:grid;grid-template-columns:repeat(4,1fr)}.gm-trust span{padding:17px 14px;text-align:center;font-size:13px;font-weight:700;border-right:1px solid var(--gm-line)}.gm-trust span:last-child{border:0}
.gm-needs-grid{display:grid;grid-template-columns:repeat(4,1fr);gap:14px}.gm-need{position:relative;display:block;aspect-ratio:4/5;overflow:hidden;background:var(--gm-soft);border-radius:6px;color:#fff}.gm-need img{width:100%;height:100%;object-fit:cover;transition:transform .35s}.gm-need:hover img{transform:scale(1.025)}.gm-need:after{content:'';position:absolute;inset:0;background:rgba(0,0,0,.34)}.gm-need-copy{position:absolute;z-index:1;left:22px;right:22px;bottom:22px}.gm-need h3{font-size:23px;line-height:1.12;margin:0 0 5px}.gm-need p{font-size:14px;margin:0;color:#fff}
.gm-featured{background:var(--gm-soft)}.gm-products{display:grid;grid-template-columns:repeat(4,1fr);gap:16px}.gm-products .product-grid__item{width:auto!important;max-width:none!important;list-style:none;background:#fff;border:1px solid var(--gm-line);border-radius:6px;overflow:hidden}.gm-products .card-gallery,.gm-products [class*=card-gallery]{aspect-ratio:1/1;background:#fff}.gm-products img{width:100%!important;height:100%!important;object-fit:contain!important}.gm-products h3{font-size:16px!important;line-height:1.35!important;margin-top:10px!important}
.gm-why{background:var(--gm-ink);color:#fff}.gm-why .gm-wrap{display:grid;grid-template-columns:minmax(260px,.7fr) 1fr;gap:clamp(30px,7vw,110px);align-items:center}.gm-why h2{font-size:clamp(31px,4vw,56px);line-height:1.04;margin:0}.gm-why p{font-size:18px;line-height:1.65;color:#dfe5df;margin:0}
body.template-index main>.shopify-section.ui-test-product-list{display:none!important}body.template-index main .hero-wrapper{min-height:min(620px,68vh);position:relative}body.template-index main .hero-wrapper:after{content:'';position:absolute;inset:0;background:rgba(0,0,0,.44);pointer-events:none}body.template-index main .hero-wrapper>*{position:relative;z-index:1}body.template-index main .hero-wrapper h1{max-width:760px;font-size:clamp(38px,5.4vw,76px)!important;line-height:1.02!important;color:#fff!important}body.template-index main .hero-wrapper p{max-width:650px;color:#fff!important;font-size:18px!important}
.gm-collection-intro{padding:54px clamp(20px,4vw,64px) 25px}.gm-filters{display:flex;gap:8px;flex-wrap:wrap;margin-top:25px}.gm-filter{display:inline-block;border:1px solid var(--gm-line);background:#fff;color:var(--gm-ink);padding:11px 17px;border-radius:5px;font:inherit;font-size:14px;font-weight:700;cursor:pointer;text-decoration:none}.gm-filter.is-active{background:var(--gm-ink);color:#fff;border-color:var(--gm-ink)}.gm-filter-empty{padding:45px 0;color:var(--gm-muted)}
.gm-legacy-collection-title{display:none!important}body.gm-collection main>.shopify-section:has(.gm-legacy-collection-title){display:none!important}body.gm-collection #ResultsList{align-items:stretch}body.gm-collection #ResultsList .product-grid__item{border:1px solid var(--gm-line);border-radius:6px;overflow:hidden;background:#fff}body.gm-collection #ResultsList .card-gallery{aspect-ratio:1/1;background:#fff}body.gm-collection #ResultsList img{width:100%!important;height:100%!important;object-fit:contain!important}body.gm-collection #ResultsList h3{font-size:16px!important;line-height:1.35!important}
.gm-assurance{display:grid;grid-template-columns:repeat(3,1fr);gap:1px;background:var(--gm-line);border:1px solid var(--gm-line);border-radius:6px;overflow:hidden;margin:18px 0}.gm-assurance span,.gm-assurance a{display:block;background:var(--gm-soft);color:var(--gm-ink);padding:13px 12px;text-align:center;font-size:12px;font-weight:700;text-decoration:none}.gm-assurance a:hover{text-decoration:underline;text-underline-offset:3px}.product-information__media img{object-fit:contain!important}.product-details h1{font-size:clamp(30px,3vw,48px)!important;line-height:1.08!important}.product-details button[type=submit]{min-height:56px;font-weight:750}.product-details details{border-top:1px solid var(--gm-line)}
html body main variant-picker[data-product-id="15681284047196"] fieldset[data-fieldset-index="0"] label.variant-option__button-label{display:flex!important}
html body main slideshow-slide.gm-833-media-allowed{display:block!important;visibility:visible!important}
.gm-footer{border-top:1px solid var(--gm-line);padding:45px clamp(20px,4vw,64px);margin-top:40px}.gm-footer-grid{width:min(1420px,100%);margin:auto;display:grid;grid-template-columns:1.5fr repeat(3,1fr);gap:40px}.gm-footer h2,.gm-footer h3{font-size:15px;margin:0 0 14px}.gm-footer p{color:var(--gm-muted);max-width:390px;line-height:1.6}.gm-footer a{display:block;color:var(--gm-ink);margin:10px 0;text-decoration:none}.gm-footer a:hover{text-decoration:underline;text-underline-offset:4px}footer .footer-utilities__group--powered-by{display:none!important}
@media(max-width:900px){header nav li.gm-extra-nav{display:none}.gm-needs-grid,.gm-products{grid-template-columns:repeat(2,1fr)}.gm-why .gm-wrap{grid-template-columns:1fr}.gm-trust .gm-wrap{grid-template-columns:repeat(2,1fr)}.gm-trust span:nth-child(2){border-right:0}.gm-trust span:nth-child(-n+2){border-bottom:1px solid var(--gm-line)}.gm-footer-grid{grid-template-columns:repeat(2,1fr)}}
@media(max-width:600px){.gm-section{padding:38px 16px}.gm-head{display:block}.gm-head .gm-view{display:inline-block;margin-top:14px}.gm-needs-grid{gap:8px}.gm-need{aspect-ratio:4/5}.gm-need-copy{left:14px;right:14px;bottom:14px}.gm-need h3{font-size:17px}.gm-need p{font-size:12px}.gm-products{grid-template-columns:repeat(2,minmax(0,1fr));gap:8px}.gm-products h3{font-size:14px!important}.gm-trust span{padding:13px 8px;font-size:11px}.gm-why p{font-size:16px}.gm-footer-grid{grid-template-columns:1fr 1fr;gap:28px 20px}.gm-footer-grid>div:first-child{grid-column:1/-1}.gm-assurance{grid-template-columns:1fr}.gm-collection-intro{padding:38px 16px 20px}body.template-index main .hero-wrapper{min-height:540px}body.template-index main .hero-wrapper:after{background:rgba(0,0,0,.54)}}`;
  document.head.appendChild(style);

  const collectionPath = `${prefix}/collections/all`;
  const safetyCollectionPaths = {
    "en": "/collections/steel-toe-safety-shoes",
    "de": "/de/collections/sicherheitsschuhe-stahlkappe",
    "fr": "/fr/collections/chaussures-securite-embout-acier",
    "it": "/it/collections/scarpe-antinfortunistiche-puntale-acciaio",
    "es": "/es/collections/zapatos-seguridad-puntera-acero"
  };
  const categoryCollectionHandles = {
    water: 'water-shoes-barefoot-shoes',
    boots: 'rain-boots-wellington-boots',
    comfort: 'everyday-comfort-shoes-insoles'
  };
  const categoryCollectionPaths = {
    safety: safetyCollectionPaths[lang],
    ...Object.fromEntries(Object.entries(categoryCollectionHandles).map(([key, handle]) => [key, `${prefix}/collections/${handle}`]))
  };
  const isCategoryKey = (key) => Object.prototype.hasOwnProperty.call(categoryCollectionPaths, key);
  const isAllCollectionPath = (pathname) => pathname.replace(/^\/(de|fr|it|es)(?=\/|$)/, '').replace(/\/$/, '') === '/collections/all';
  const collectionHref = (source) => {
    const target = new URL(collectionPath, location.origin);
    if (source) {
      const original = new URL(source, location.origin);
      if (original.origin === location.origin) { target.search = original.search; target.hash = original.hash; }
    }
    target.searchParams.delete('gm_category');
    target.searchParams.delete('page');
    return target.pathname + target.search + target.hash;
  };
  const categoryHref = (key, source) => {
    if (!isCategoryKey(key)) return null;
    const targetPath = categoryCollectionPaths[key];
    const target = new URL(targetPath, location.origin);
    if (source) {
      const original = new URL(source, location.origin);
      if (original.origin === location.origin) { target.search = original.search; target.hash = original.hash; }
    }
    target.searchParams.delete('gm_category');
    target.searchParams.delete('page');
    return target.pathname + target.search + target.hash;
  };
  const legacyCategoryKey = (url) => {
    if (url.origin !== location.origin || !isAllCollectionPath(url.pathname)) return null;
    const key = url.searchParams.get('gm_category');
    return isCategoryKey(key) ? key : null;
  };
  const categoryKeyForURL = (url) => {
    if (url.origin !== location.origin) return null;
    const legacyKey = legacyCategoryKey(url);
    if (legacyKey) return legacyKey;
    const pathname = url.pathname.replace(/\/$/, '');
    if (Object.values(safetyCollectionPaths).includes(pathname)) return 'safety';
    const pathWithoutLocale = pathname.replace(/^\/(de|fr|it|es)(?=\/|$)/, '');
    return Object.entries(categoryCollectionHandles).find(([, handle]) => pathWithoutLocale === `/collections/${handle}`)?.[0] || null;
  };
  const redirectLegacyCategory = () => {
    const url = new URL(location.href);
    const key = legacyCategoryKey(url);
    if (!key) return false;
    if (!redirectLegacyCategory.started) {
      redirectLegacyCategory.started = true;
      location.replace(categoryHref(key, location.href));
    }
    return true;
  };
  const categories = [
    {key: 'safety', label: copy.safety, sub: copy.safetySub, match: /steel-toe/},
    {key: 'water', label: copy.water, sub: copy.waterSub, match: /(barefoot|water-shoes|bathing-slippers)/},
    {key: 'boots', label: copy.boots, sub: copy.bootsSub, match: /(deck-boots|rain-boots|wellington-boots)/},
    {key: 'comfort', label: copy.comfort, sub: copy.comfortSub, match: /(insoles|orthopedic|comfort)/}
  ];

  const cleanTitle = (text) => text.replace(/^(GemChve|gojiang|SmoothPace|WaVkMoxy)\s*/i, '').trim();
  const cardData = (card) => {
    const link = card.querySelector('a[href*="/products/"]');
    const img = card.querySelector('img');
    return {card, href: link?.getAttribute('href') || '', src: img?.currentSrc || img?.src || img?.getAttribute('src') || ''};
  };
  const fetchCards = async () => {
    try {
      const html = await fetch(collectionPath, {credentials: 'same-origin'}).then((r) => r.text());
      const doc = new DOMParser().parseFromString(html, 'text/html');
      return [...doc.querySelectorAll('#ResultsList li.product-grid__item')];
    } catch (_) { return []; }
  };

  const enhanceAnnouncement = () => {
    const p = document.querySelector('[role=complementary] p, aside p');
    if (p) p.textContent = copy.announcement;
  };
  const enhanceHeader = () => {
    if (path === '/') {
      document.querySelectorAll('header h1').forEach((heading) => {
        if (!/GemChve/i.test(heading.textContent || '')) return;
        const brand = document.createElement('div');
        [...heading.attributes].forEach((attr) => brand.setAttribute(attr.name, attr.value));
        brand.innerHTML = heading.innerHTML;
        heading.replaceWith(brand);
      });
    }
    document.querySelectorAll('header nav a').forEach((link) => {
      const url = new URL(link.href, location.origin);
      const key = categoryKeyForURL(url);
      const category = categories.find((item) => item.key === key);
      if (category) {
        const localizedHref = categoryHref(category.key, link.href);
        if (legacyCategoryKey(url) && link.closest('li.gm-extra-nav') && link.textContent.trim() !== category.label) link.textContent = category.label;
        if (link.getAttribute('href') !== localizedHref) link.setAttribute('href', localizedHref);
        return;
      }
      if (url.origin === location.origin && isAllCollectionPath(url.pathname)) {
        if (link.textContent.trim() !== copy.shop) link.textContent = copy.shop;
        if (link.getAttribute('href') !== collectionPath) link.setAttribute('href', collectionPath);
      }
    });
    const lists = [...new Set([...document.querySelectorAll('nav a')].filter((link) => {
      const url = new URL(link.href, location.origin);
      return url.origin === location.origin && isAllCollectionPath(url.pathname);
    }).map((link) => link.closest('ul')).filter(Boolean))];
    lists.forEach((nav) => {
      const links = [...nav.querySelectorAll('a')];
      const catalog = links.find((a) => {
        const url = new URL(a.href, location.origin);
        return url.origin === location.origin && isAllCollectionPath(url.pathname) && !url.searchParams.has('gm_category');
      }) || links.find((a) => {
        const url = new URL(a.href, location.origin);
        return url.origin === location.origin && /catalog|katalog|catalogue|catálogo|catalogo/i.test(a.textContent);
      });
      if (!catalog) return;
      if (catalog.textContent.trim() !== copy.shop) catalog.textContent = copy.shop;
      if (catalog.getAttribute('href') !== collectionPath) catalog.setAttribute('href', collectionPath);
      categories.forEach((item) => {
        const matches = [...nav.querySelectorAll('a')].filter((a) => {
          const url = new URL(a.href, location.origin);
          return categoryKeyForURL(url) === item.key;
        });
        const existing = matches.find((a) => !a.closest('.gm-extra-nav')) || matches[0];
        matches.filter((a) => a !== existing).forEach((a) => {
          const extra = a.closest('li.gm-extra-nav');
          if (extra?.parentElement === nav && extra.querySelectorAll('a').length === 1) extra.remove();
        });
        const localizedHref = categoryHref(item.key, existing?.href);
        if (existing) {
          if (existing.getAttribute('href') !== localizedHref) existing.setAttribute('href', localizedHref);
          return;
        }
        const li = document.createElement('li');
        li.className = 'gm-extra-nav';
        li.innerHTML = `<a href="${localizedHref}">${item.label}</a>`;
        nav.appendChild(li);
      });
    });
  };
  const observeHeader = () => {
    const target = document.body;
    if (!target || target.dataset.gmHeaderObserved) return;
    target.dataset.gmHeaderObserved = 'true';
    let runs = 0;
    const observer = new MutationObserver(() => {
      enhanceHeader();
      runs += 1;
      if (runs >= 24) observer.disconnect();
    });
    observer.observe(target, {childList: true, subtree: true});
    setTimeout(() => observer.disconnect(), 12000);
  };
  const trustHtml = () => `<div class="gm-trust"><div class="gm-wrap"><span>${copy.trust1}</span><span>${copy.trust2}</span><span>${copy.trust3}</span><span>${copy.trust4}</span></div></div>`;
  const enhanceHome = async () => {
    if (path !== '/' || document.querySelector('.gm-needs') || enhanceHome.inFlight) return;
    const main = document.querySelector('main');
    const hero = main?.querySelector('.hero-wrapper') || main?.firstElementChild;
    if (!main || !hero) return;
    enhanceHome.inFlight = true;
    const nativeSections = [...main.querySelectorAll(':scope > .shopify-section.ui-test-product-list')];
    const restoreNative = () => nativeSections.forEach((section) => {
      section.style.setProperty('display', 'block', 'important');
      section.dataset.gmHomeFallback = 'true';
    });
    try {
      document.body.classList.add('template-index');
      let heading = hero.querySelector('h1,h2');
      const para = hero.querySelector('p');
      if (!heading && para?.parentElement) {
        heading = document.createElement('h1');
        para.parentElement.insertBefore(heading, para);
      }
      const button = hero.querySelector('a[href],button');
      if (heading) heading.textContent = copy.hero;
      if (para) para.textContent = copy.heroSub;
      if (button) { button.textContent = copy.heroCta; if (button.tagName === 'A') button.href = collectionPath; }
      const cards = await fetchCards();
      if (document.querySelector('.gm-needs') || !hero.isConnected) return;
      const native266 = nativeSections.map((section) => section.querySelector('product-card[data-product-id="15668798882140"]')).find(Boolean);
      if (!native266 || !cards.length) { restoreNative(); return; }
      const seen = new Set();
      const selected = [native266, ...cards].filter((card) => {
        const info = cardData(card);
        if (!info.href) return false;
        const url = new URL(info.href, location.origin);
        if (url.origin !== location.origin || !url.pathname.includes('/products/')) return false;
        const productId = card.getAttribute('data-product-id') || card.querySelector('[data-product-id]')?.getAttribute('data-product-id');
        const keys = [url.pathname.replace(/^\/(de|fr|it|es)(?=\/|$)/, '')];
        if (productId) keys.push('id:' + productId);
        if (keys.some((key) => seen.has(key))) return false;
        keys.forEach((key) => seen.add(key));
        return true;
      });
      if (selected[0] !== native266) { restoreNative(); return; }
      const stripBindings = (node) => {
        [node, ...node.querySelectorAll('*')].forEach((element) => {
          [...element.attributes].forEach((attr) => {
            if (/^on/i.test(attr.name) || ['id', 'ref', 'for', 'form', 'aria-labelledby', 'aria-describedby', 'aria-controls', 'aria-owns'].includes(attr.name)) element.removeAttribute(attr.name);
          });
        });
        node.querySelectorAll('script,style,form,button,input,select,textarea,quick-add-component,product-form-component,add-to-cart-component').forEach((element) => element.remove());
        return node;
      };
      const linkCards = selected.map((card) => {
        const link = card.querySelector('a[ref="productTitleLink"]') || card.querySelector('a[href*="/products/"]');
        const title = link?.textContent.trim();
        const img = card.querySelector('slideshow-slide[aria-hidden="false"]:not([hidden]) img') || card.querySelector('img');
        const price = card.querySelector('product-price,[ref="priceContainer"],.price');
        if (!link || !title || !img || !price) return null;
        const item = document.createElement('li');
        item.className = 'product-grid__item';
        const entry = document.createElement('a');
        entry.className = 'product-card__content';
        entry.setAttribute('href', link.getAttribute('href'));
        const gallery = document.createElement('div');
        gallery.className = 'card-gallery';
        gallery.appendChild(stripBindings(img.cloneNode(true)));
        const titleNode = document.createElement('h3');
        titleNode.textContent = cleanTitle(title);
        const priceNode = document.createElement('div');
        priceNode.className = price.className;
        priceNode.innerHTML = price.innerHTML;
        entry.append(gallery, titleNode, stripBindings(priceNode));
        item.appendChild(entry);
        return item;
      });
      if (!linkCards[0]) { restoreNative(); return; }
      const featured = linkCards.filter(Boolean).slice(0, 4);
      if (featured.length < 4) { restoreNative(); return; }
      const data = linkCards.filter(Boolean).map(cardData);
      const needs = categories.map((item) => {
        const found = item.key === 'safety' ? cardData(linkCards[0]) : data.find((d) => item.match.test(d.href));
        const img = document.createElement('img');
        if (found?.src) { img.src = found.src; img.alt = item.label; img.loading = 'lazy'; }
        return '<a class="gm-need" href="' + categoryHref(item.key) + '"' + (found?.src ? '' : ' style="background:var(--gm-ink)"') + '>' + (found?.src ? img.outerHTML : '') + '<div class="gm-need-copy"><h3>' + item.label + '</h3><p>' + item.sub + '</p></div></a>';
      }).join('');
      const sections = document.createElement('div');
      sections.className = 'gm-needs';
      sections.innerHTML = `<section class="gm-section"><div class="gm-wrap"><div class="gm-head"><div><h2>${copy.needs}</h2><p>${copy.needsSub}</p></div><a class="gm-view" href="${collectionPath}">${copy.view}</a></div><div class="gm-needs-grid">${needs}</div></div></section><section class="gm-section gm-featured"><div class="gm-wrap"><div class="gm-head"><div><h2>${copy.popular}</h2><p>${copy.popularSub}</p></div><a class="gm-view" href="${collectionPath}">${copy.view}</a></div><ul class="gm-products"></ul></div></section><section class="gm-section gm-why"><div class="gm-wrap"><h2>${copy.why}</h2><p>${copy.whySub}</p></div></section>`;
      featured.forEach((card) => sections.querySelector('.gm-products').appendChild(card));
      if (document.querySelector('.gm-needs') || !hero.isConnected) return;
      if (!main.querySelector('.gm-trust')) hero.insertAdjacentHTML('afterend', trustHtml());
      const trust = main.querySelector('.gm-trust');
      trust.parentNode.insertBefore(sections, trust.nextSibling);
      nativeSections.filter((section) => section.dataset.gmHomeFallback === 'true').forEach((section) => {
        section.style.removeProperty('display');
        delete section.dataset.gmHomeFallback;
      });
    } catch (_) {
      if (!document.querySelector('.gm-needs')) restoreNative();
    } finally {
      enhanceHome.inFlight = false;
    }
  };
  const enhanceCollection = () => {
    if (path !== '/collections/all' || document.querySelector('.gm-collection-intro')) return;
    const main = document.querySelector('main');
    const results = main?.querySelector('#ResultsList');
    if (!main || !results) return;
    document.body.classList.add('gm-collection');
    document.title = `${copy.collection} | GemChve`;
    let description = document.querySelector('meta[name="description"]');
    if (!description) { description = document.createElement('meta'); description.name = 'description'; document.head.appendChild(description); }
    description.content = copy.collectionSub;
    const intro = document.createElement('section');
    intro.className = 'gm-collection-intro';
    intro.innerHTML = `<div class="gm-wrap"><h1>${copy.collection}</h1><p>${copy.collectionSub}</p><div class="gm-filters"><a class="gm-filter is-active" href="${collectionHref(location.href)}" aria-current="page">${copy.all}</a>${categories.map((item) => `<a class="gm-filter" href="${categoryHref(item.key, location.href)}">${item.label}</a>`).join('')}</div></div>`;
    const legacyTitle = [...main.querySelectorAll('h1')].find((h) => /^(Products|Produkte|Produits|Prodotti|Productos)$/i.test(h.textContent.trim()));
    if (legacyTitle) {
      (legacyTitle.closest('.shopify-section') || legacyTitle.parentElement).classList.add('gm-legacy-collection-title');
      legacyTitle.remove();
    }
    main.insertBefore(intro, main.firstElementChild);
    [...results.querySelectorAll('li.product-grid__item')].forEach((card) => {
      const h = card.querySelector('h3:not(.visually-hidden)');
      if (h) h.textContent = cleanTitle(h.textContent);
    });
  };
  const enhanceProduct = () => {
    if (!path.startsWith('/products/')) return;
    const details = document.querySelector('.product-details');
    if (!details || details.querySelector('.gm-assurance')) return;
    const box = document.createElement('div');
    box.className = 'gm-assurance';
    box.innerHTML = `<span>${copy.assurance1}</span><a href="${prefix}/policies/shipping-policy">${copy.assurance2}</a><a href="${prefix}/policies/refund-policy">${copy.assurance3}</a>`;
    const button = details.querySelector('button[type=submit]');
    const target = button?.closest('form,[class*=buy],[class*=product-form]') || button;
    if (target) target.insertAdjacentElement('afterend', box); else details.prepend(box);
  };
  const enforceModel833Media = () => {
    if (!path.includes('/products/gojiang-air-cushion-running-trainers-833')) return;
    const rawColor = document.querySelector('variant-picker[data-product-id="15681284047196"] fieldset[data-fieldset-index="0"] input:checked')?.value;
    const colorAliases = {
      'Schwarz/Weiß': 'Black White',
      'Grau/Rosa': 'Grey Pink',
      'Schwarz/Rot': 'Black Red',
      'Rosa': 'Pink',
      'Schwarz/Rosa': 'Black Pink',
      'Grau/Orange': 'Grey Orange',
      'Schwarz/Grün': 'Black Green',
      'Blau/Rosa': 'Blue Pink',
      'Schwarz/Orange': 'Black Orange',
      'Blau/Orange': 'Blue Orange',
      'Noir/Blanc': 'Black White',
      'Gris/Rose': 'Grey Pink',
      'Noir/Rouge': 'Black Red',
      'Rose': 'Pink',
      'Noir/Rose': 'Black Pink',
      'Gris/Orange': 'Grey Orange',
      'Noir/Vert': 'Black Green',
      'Bleu/Rose': 'Blue Pink',
      'Noir/Orange': 'Black Orange',
      'Bleu/Orange': 'Blue Orange',
      'Nero/Bianco': 'Black White',
      'Grigio/Rosa': 'Grey Pink',
      'Nero/Rosso': 'Black Red',
      'Nero/Rosa': 'Black Pink',
      'Grigio/Arancione': 'Grey Orange',
      'Nero/Verde': 'Black Green',
      'Blu/Rosa': 'Blue Pink',
      'Nero/Arancione': 'Black Orange',
      'Blu/Arancione': 'Blue Orange',
      'Negro/Blanco': 'Black White',
      'Gris/Rosa': 'Grey Pink',
      'Negro/Rojo': 'Black Red',
      'Negro/Rosa': 'Black Pink',
      'Gris/Naranja': 'Grey Orange',
      'Negro/Verde': 'Black Green',
      'Azul/Rosa': 'Blue Pink',
      'Negro/Naranja': 'Black Orange',
      'Azul/Naranja': 'Blue Orange'
    };
    const color = colorAliases[rawColor] || rawColor;
    const mediaByColor = {
      'Black White': [
        '61Tfy_oaEgL._AC_SL1500.jpg',
        '71vm6h-GhdL._AC_SL1500.jpg',
        '61kHIuBc0xL._AC_SL1500.jpg',
        '61trlLCvuZL._AC_SL1500.jpg',
        '61UcRfO-mBL._AC_SL1500.jpg',
        '618zdIH73OL._AC_SL1500.jpg',
        '61Atge_TmhL._AC_SL1500.jpg'
      ],
      'Grey Pink': [
        '81oEQ72B9WL._AC_SL1500.jpg',
        '71osmVrvloL._AC_SL1500.jpg',
        '81N6-VB1rDL._AC_SL1500.jpg',
        '819rGh9KTuL._AC_SL1500.jpg',
        '71L6m28g9LL._AC_SL1500.jpg',
        '61trjx4bTrL._AC_SL1500.jpg'
      ],
      'Black Red': [
        '61meNLsfFnL._AC_SL1500.jpg',
        '616guQM4qkL._AC_SL1500.jpg',
        '71fq19jxZbL._AC_SL1500.jpg',
        '61hkH9vO1sL._AC_SL1500.jpg',
        '71hl9KaFooL._AC_SL1500.jpg',
        '61Ar8tTKufL._AC_SL1500.jpg',
        '71dLvDPO14L._AC_SL1500.jpg'
      ],
      'Pink': [
        '710N_7ne6sL._AC_SL1500.jpg',
        '61dbRkKSxWL._AC_SL1500.jpg',
        '61fBietmUhL._AC_SL1500.jpg',
        '61LgXNeWV8L._AC_SL1500.jpg',
        '61t1AkVInmL._AC_SL1500.jpg',
        '61pkAYVPVaL._AC_SL1500.jpg'
      ],
      'Black Pink': [
        '61l0iN4t83L._AC_SL1500.jpg',
        '71g8sGLO_NL._AC_SL1500.jpg',
        '71-3NT5EizL._AC_SL1500.jpg',
        '61Dk5sZc_WL._AC_SL1500.jpg',
        '614Zf1pFb0L._AC_SL1500.jpg',
        '71g3uNd98hL._AC_SL1500.jpg',
        '61jQ7Z-miyL._AC_SL1500.jpg'
      ],
      'Grey Orange': [
        '71KXWqadoCS._AC_SL1500.jpg',
        '71Gtv0rJaiL._AC_SL1500.jpg',
        '61dzyvBi2zL._AC_SL1500.jpg',
        '71cJuKQLi3L._AC_SL1500.jpg',
        '619qZtCK7rL._AC_SL1500.jpg',
        '61d6OwXBGjL._AC_SL1500.jpg'
      ],
      'Black Green': [
        'gemchve-833-black-green-primary-1200.jpg',
        '51XmMpZk-SS._AC_SL1500.jpg',
        '518PelSnWrS._AC_SL1500.jpg',
        '51jBsYd5vXS._AC_SL1500.jpg',
        '51sdOfb3SzS._AC_SL1500.jpg',
        '51A0pVOOOQS._AC_SL1500.jpg',
        '51PDtwGUOZS._AC_SL1500.jpg'
      ],
      'Blue Pink': [
        '41HZEzAd9gL._AC_SL1500.jpg',
        '41NLKpWxrWL._AC_SL1500.jpg',
        '51SFbzCdIZL._AC_SL1500.jpg',
        '51S-5MPp_vL._AC_SL1500.jpg',
        '41hZQEEdDbL._AC_SL1500.jpg',
        '41pIJN3rMnL._AC_SL1500.jpg',
        '71W7GOZbUVL._AC_SL1500.jpg'
      ],
      'Black Orange': [
        '41AxptwByLL._AC_SL1500.jpg',
        '61-rQyi1BrL._AC_SL1500.jpg',
        '51euuJBr7RL._AC_SL1500.jpg',
        '51DSIn4EvuL._AC_SL1500.jpg',
        '51uR0W-W4DL._AC_SL1500.jpg',
        '615McqvmvBL._AC_SL1500.jpg'
      ],
      'Blue Orange': [
        '41AxptwByLL._AC_SL1500.jpg',
        '61-rQyi1BrL._AC_SL1500.jpg',
        '51euuJBr7RL._AC_SL1500.jpg',
        '51DSIn4EvuL._AC_SL1500.jpg',
        '51uR0W-W4DL._AC_SL1500.jpg',
        '615McqvmvBL._AC_SL1500.jpg'
      ]
    };
    const allowed = new Set(mediaByColor[color] || []);
    if (!allowed.size) return;
    const nodes = document.querySelectorAll('main slideshow-slide, main .product-media-container[data-media-id]');
    nodes.forEach((node) => {
      const image = node.querySelector('img');
      const file = image ? new URL(image.currentSrc || image.src, location.origin).pathname.split('/').pop() : '';
      const visible = allowed.has(file);
      node.classList.toggle('gm-833-media-allowed', visible);
      node.setAttribute('aria-hidden', visible ? 'false' : 'true');
      node.hidden = !visible;
      if (visible) {
        node.style.removeProperty('display');
        node.style.removeProperty('visibility');
      } else {
        node.style.setProperty('display', 'none', 'important');
        node.style.setProperty('visibility', 'hidden', 'important');
      }
    });
  };
  const scheduleModel833Media = () => [0, 80, 240, 700].forEach((delay) => setTimeout(enforceModel833Media, delay));
  const fixCookiePreferenceLink = () => {
    document.querySelectorAll('a[href*="/policies/#shopifyReshowConsentBanner"]').forEach((link) => {
      link.setAttribute('href', '#shopifyReshowConsentBanner');
    });
  };
  const enhanceFooter = () => {
    const footer = document.querySelector('footer');
    if (!footer || footer.querySelector('.gm-footer')) return;
    const section = document.createElement('section');
    section.className = 'gm-footer';
    section.innerHTML = `<div class="gm-footer-grid"><div><h2>GemChve</h2><p>${copy.aboutText}</p></div><div><h3>${copy.shop}</h3>${categories.map((item) => `<a href="${categoryHref(item.key)}">${item.label}</a>`).join('')}<a href="${collectionPath}">${copy.shop}</a></div><div><h3>${copy.help}</h3><a href="${prefix}/pages/contact">${copy.contact}</a><a href="${prefix}/policies/shipping-policy">${copy.shipping}</a><a href="${prefix}/policies/refund-policy">${copy.refund}</a></div><div><h3>${copy.legal}</h3><a href="${prefix}/policies/privacy-policy">${copy.privacy}</a><a href="${prefix}/policies/terms-of-service">${copy.terms}</a></div></div>`;
    footer.prepend(section);
    const powered = [...footer.querySelectorAll('a')].find((a) => /shopify\.com/i.test(a.href) && /Powered/i.test(a.textContent));
    if (powered) powered.style.display = 'none';
  };
  document.addEventListener('click', (event) => {
    if (event.button != null && event.button !== 0) return;
    const target = event.target instanceof Element ? event.target : event.target?.parentElement;
    const button = target?.closest('button.quick-add__button--choose[type="button"]');
    const card = button?.closest('product-card');
    if (!card || card.getAttribute('data-product-id') !== '15668798882140') return;
    event.preventDefault();
    event.stopImmediatePropagation();
    const link = card.querySelector('a[ref="productTitleLink"]') || card.querySelector('a[ref="productCardLink"]');
    const href = link?.getAttribute('href');
    if (!href || link.closest('product-card') !== card) return;
    try {
      const url = new URL(href, location.href);
      const variants = url.searchParams.getAll('variant');
      if (url.origin !== location.origin || url.username || url.password ||
          !new RegExp('^' + prefix + '/products/[^/]+/?$').test(url.pathname) ||
          variants.length !== 1 || !/^[1-9][0-9]*$/.test(variants[0])) return;
      location.assign(url.href);
    } catch (_) { /* Keep an invalid 266 entry out of the default-size modal. */ }
  }, true);
  document.addEventListener('change', (event) => {
    if (event.target.matches('variant-picker[data-product-id="15681284047196"] fieldset[data-fieldset-index="0"] input')) scheduleModel833Media();
  }, true);
  const run = () => { if (redirectLegacyCategory()) return; enhanceAnnouncement(); enhanceHeader(); observeHeader(); enhanceCollection(); enhanceProduct(); enhanceFooter(); enhanceHome(); fixCookiePreferenceLink(); scheduleModel833Media(); };
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', run, {once: true}) : run();
  setTimeout(run, 700);
  setTimeout(run, 1800);
  setTimeout(run, 3500);
  setTimeout(run, 6500);
})();
